export class DisStudentLevelOfDevelopment {
    id: number; 
    studentId: number;
    levelOfDevelopmentId : number;
    levelOfDevelopmentName : string;
    levelOfDevelopmentTypeId : number;
    levelOfDevelopmentTypeName : string;
      
} 